
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.159 24.512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Date_Functions","data-name":"Date Functions","transform":"translate(-869.25 -314.221)"}},[_c('g',{attrs:{"id":"Group_18574","data-name":"Group 18574","transform":"translate(870 314.971)"}},[_c('g',{attrs:{"id":"Group_18557","data-name":"Group 18557"}},[_c('g',{attrs:{"id":"Group_18562","data-name":"Group 18562","fill":"none","stroke":"#6d7f93","stroke-miterlimit":"10","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_924","data-name":"Path 924","d":"M53.373 3.578h-2.125a3.053 3.053 0 00-3.05 3.05v15.711a3.053 3.053 0 003.05 3.049h17.559a3.053 3.053 0 003.05-3.049V6.628a3.053 3.053 0 00-3.05-3.05H53.373M48.2 9.862h23.657","transform":"translate(-48.198 -2.377)"}}),_c('line',{attrs:{"id":"Line_389","data-name":"Line 389","y1":"2.403","transform":"translate(6.865)","stroke-linecap":"round"}}),_c('line',{attrs:{"id":"Line_390","data-name":"Line 390","y1":"2.403","transform":"translate(16.794)","stroke-linecap":"round"}})])])])])])
          )
        }
      }
    